import React, { useState } from 'react';
import { RefreshCw, Trash2 } from 'lucide-react';
import { clearAllCache, forceReload } from '../utils/clearCache';
import Button from './Button';

const CacheCleaner: React.FC = () => {
  const [isClearing, setIsClearing] = useState(false);

  const handleClearCache = async () => {
    if (window.confirm('This will clear all cached data and reload the page. Continue?')) {
      setIsClearing(true);
      const success = await clearAllCache();
      
      if (success) {
        setTimeout(() => {
          forceReload();
        }, 1000);
      } else {
        alert('Failed to clear some caches. Please try manually clearing your browser cache.');
        setIsClearing(false);
      }
    }
  };

  return (
    <Button
      onClick={handleClearCache}
      disabled={isClearing}
      variant="secondary"
      size="small"
      className="flex items-center gap-2"
    >
      {isClearing ? (
        <>
          <RefreshCw className="w-4 h-4 animate-spin" />
          Clearing...
        </>
      ) : (
        <>
          <Trash2 className="w-4 h-4" />
          Clear Cache
        </>
      )}
    </Button>
  );
};

export default CacheCleaner;
